import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import AppBar from "../components/AppBar";
import Toolbar from "../components/Toolbar";
import { Link as RouterLink } from "react-router-dom";

const rightLink = {
  fontSize: 16,
  color: "common.white",
  ml: 3,
};

function AppAppBar() {
  return (
    <>
      <AppBar position="absolute" color="transparent">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* <Box sx={{ flex: 1 }} /> */}
          <Link
            variant="h6"
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/"
            sx={{ fontSize: 24 }}
          >
            {"scs"}
          </Link>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <Link
              color="inherit"
              variant="h6"
              underline="none"
              component={RouterLink}
              to="/academics/"
              sx={rightLink}
            >
              {"Academics"}
            </Link>
            <Link
              color="inherit"
              variant="h6"
              underline="none"
              href="https://wa.me/9060203615?text=Hi,%20can%20you%20please%20call%20me%20back%20on%20this%20number?"
              sx={{ ...rightLink }}
            >
              {"Contact"}
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
}

export default AppAppBar;
